import { styled } from "@mui/material/styles"
import { Stack } from "@mui/material"

export const QuestionStack = styled(Stack)({
    padding: 1,
})
